"use client";

import React, {useContext, useEffect} from 'react';
import { usePathname } from 'next/navigation';
import { Container, Link, Box, Stack } from '@mui/material';
import Symbol from "../symbol";
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Grid from '@mui/material/Unstable_Grid2';
import {Basket} from "../../context/basket";

const Footer = () => {
    const pathname = usePathname();

    const shouldShowContent = () => {
        const excludedPaths = ['/basket', '/checkout'];
        const allowedPaths = ['/checkout/success'];

        if (allowedPaths.includes(pathname)) return true;

        if (excludedPaths.some(path => pathname.startsWith(path))) return false;

        return true;
    };

    const showContent = shouldShowContent();

    useEffect(() => {
        const existingScript = document.getElementById('legitScript');
        if (!existingScript) {
            const script = document.createElement('script');
            script.id = 'legitScript';
            script.src = "https://static.legitscript.com/seals/6918785.js";
            script.async = true;

            const placeholder = document.getElementById('legitScriptPlaceholder');
            if (placeholder !== null) {
                placeholder.appendChild(script);

                return () => {
                    placeholder.removeChild(script);
                };
            }
        }
    }, []);

    const currentYear = new Date().getFullYear();
    const basket = useContext(Basket);
    if (typeof basket?.data?.quote?.quote === 'undefined') {
        return;
    }

    return (
        <Box component="footer" sx={{ width: '100%' }} className="bg-black">
            <Container>
                <Grid container xs={12}>
                    {/*{showContent &&(*/}
                    {/*<Grid xs={12} className="flex-end">*/}
                    {/*    <Symbol maxWidth="200px" />*/}
                    {/*</Grid>*/}
                    {/*)}*/}
                    {showContent &&(
                        <Grid container className="margin-y-3" xs={12}>
                            <Grid xs={12} sm={4} md={3} lg={3} className="margin-y-1">
                                <h3>Sons</h3>
                                <Box>
                                    <Link className="border-0 margin-top-0" href="https://sons.co.uk/pages/about"
                                          target="_parent" display="block">About
                                        Us</Link><br/>
                                    <Link href="https://sons.co.uk/pages/people-and-planet" target="_parent"
                                          display="block">People & Planet</Link><br/>
                                    <Link href="https://sons.co.uk/pages/hair-loss-science" target="_parent"
                                          display="block">Hair Loss Science</Link><br/>
                                    <Link href="https://sons.co.uk/blogs/testimonials" target="_parent"
                                          display="block">Testimonials</Link><br/>
                                    <Link href="https://sons.co.uk/blogs/journal" target="_parent" display="block">Our
                                        Blog</Link><br/>
                                    <Link href="https://sons.co.uk/pages/refer-a-friend" target="_parent"
                                          display="block">Refer
                                        A Friend</Link><br/>
                                    <Link href="https://sons.co.uk/pages/faqs" target="_parent"
                                          display="block">FAQs</Link>
                                </Box>
                            </Grid>
                            <Grid xs={12} sm={4} md={3} lg={3} className="margin-y-1">
                                <h3>Legal Info</h3>
                                <Box>
                                <Link className="border-0 margin-top-0" href="https://sons.co.uk/pages/delivery-returns" target="_parent" display="block">Delivery
                                    & Info</Link><br/>
                                <Link href="https://sons.co.uk/pages/terms-conditions" target="_parent" display="block">Terms
                                    & Conditions</Link><br/>
                                <Link href="https://sons.co.uk/pages/sons-privacy-policy" target="_parent"
                                      display="block">Privacy Policy</Link><br/>
                                <Link href="https://sons.co.uk/pages/refund-policy" target="_parent" display="block">Refund
                                    Policy</Link><br/>
                                <Link href="https://sons.co.uk/pages/complaints" target="_parent" display="block">Make A
                                    Complaint</Link><br/>
                                <Link
                                    href="https://cdn.shopify.com/s/files/1/0255/7725/9086/files/1657517955_PIPL_Policy_Certificate.pdf?v=1699374958"
                                    target="_parent" display="block">Indemnity Insurance</Link><br/>
                                <Link href="https://www.chemist-4-u.com/responsible-pharmacist" target="_parent"
                                      display="block">Responsible Pharmacist</Link>
                                </Box>
                            </Grid>
                            <Grid xs={12} sm={3} md={3} lg={3} className="margin-y-1">
                                <h3>Get In Touch</h3>
                                <p className="margin-bottom-0">hello@sons.co.uk</p>
                                <p>0208 154 2524</p>
                                <Stack direction="row" spacing={1}>
                                    <a href="https://www.facebook.com/careforsons" target="_blank">
                                        <FacebookIcon sx={ { fill: '#dddddd' } } />
                                    </a>
                                    <a href="https://twitter.com/CareforSons" target="_blank">
                                        <TwitterIcon sx={ { fill: '#dddddd' } } />
                                    </a>
                                    <a href="https://www.instagram.com/careforsons/" target="_blank">
                                        <InstagramIcon sx={ { fill: '#dddddd' } } />
                                    </a>
                                    <a href="https://www.youtube.com/channel/UCID902Y0zPQIKFbIlRlwURA/"
                                          target="_blank">
                                        <YouTubeIcon sx={ { fill: '#dddddd' } } />
                                    </a>
                                </Stack>
                            </Grid>
                            <Grid xs={12} md={3}>
                            </Grid>
                        </Grid>
                    )}
                    <Grid container xs={12} className="margin-y-3">
                        <Grid xs={12} md={4} className="margin-y-1 padding-desktop-right-4">
                            <Box>
                                <Grid container xs={12}>
                                    <Grid xs={6}>
                                        <a id='lnkPharmacyRegulation'
                                           href='https://www.pharmacyregulation.org/registers/pharmacy/registrationnumber/9011784'
                                           style={{marginRight: "10px"}}>
                                            <img id='imgLogo' alt='Online Pharmacy Logo'
                                                 src='https://cdn.shopify.com/s/files/1/0255/7725/9086/t/39/assets/registered_pham.png?v=1674818236'
                                                 style={{height: "36px", width: "91px", borderWidth: "0px"}}/>
                                        </a>
                                    </Grid>
                                    <Grid xs={6}>
                                        <Box id="legitScriptPlaceholder"></Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid xs={12} md={4} className="margin-y-1 padding-desktop-right-4">
                            <small className="micro md-grey">Chemist 4 U is our partner pharmacy and prescribing service.
                                Innox Trading Ltd, 34a-37 Greenhey Place, Lancashire, WN8 9SA</small>
                        </Grid>
                        <Grid xs={12} md={4} className="margin-y-1 padding-desktop-right-4">
                            <small className="micro md-grey">Our medical products have been licensed for sale in the UK and are regulated by the Medicines & Healthcare products Regulatory Agency (MHRA).</small>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md={8}>
                    </Grid>
                    <Grid xs={12} md={4} className="margin-bottom-4 md-grey">
                        ©{currentYear} <a href="https://sons.co.uk/" className="copyright">CAREFORSONS LTD</a>. ALL RIGHTS RESERVED.
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Footer;
